<div [class.container]="!embedded" [class.box]="!embedded" [class.mt-4]="!embedded" [class.firma-embedded]="embedded">
  <form>
    <div class="form-group row" [class.firma-embedded-form]="embedded">
      <div class="col-12" *ngIf="!embedded">
        <label for="" class="text-title" style="font-size: 18px">Firmar guía</label>
      </div>

      <div class="col-12" *ngIf="!embedded"><br /></div>

      <!-- Embedded: horizontal layout -->
      <ng-container *ngIf="embedded">
        <div class="firma-form-row">
          <label class="firma-form-label" for="firmaNombre">NOMBRE</label>
          <div class="firma-form-field">
            <input
              id="firmaNombre"
              class="form-control firma-form-control"
              type="text"
              name="NombreRecptor"
              [(ngModel)]="data.name"
              placeholder="Ingresa tu nombre" />
          </div>
        </div>

        <div class="firma-form-row">
          <label class="firma-form-label" for="firmaRut">RUT</label>
          <div class="firma-rut-group">
            <input
              id="firmaRut"
              class="form-control firma-form-control firma-rut-main"
              type="text"
              name="RutReceptor"
              [(ngModel)]="data.rut"
              placeholder="Ingresa tu RUT"
              (keydown)="onKeyDown($event)" />
            <input
              class="form-control firma-form-control firma-rut-dv"
              type="text"
              maxlength="1"
              name="dvRutReceptor"
              [(ngModel)]="data.dvrut"
              placeholder="DV"
              (ngModelChange)="onDvRutChange($event)"
              (keydown)="onKeyDown($event)" />
          </div>
        </div>

        <div class="firma-form-row">
          <label class="firma-form-label" for="firmaCorreo">CORREO</label>
          <div class="firma-correo-wrap">
            <input
              id="firmaCorreo"
              class="form-control firma-form-control"
              type="email"
              name="mailReceptor"
              [(ngModel)]="data.mail"
              placeholder="Ingresa tu correo"
              #mailEmbedded="ngModel"
              [ngModelOptions]="{ updateOn: 'blur' }"
              [pattern]="emailPattern" />
            <small class="firma-correo-hint">
              Este correo lo utilizaremos para mandarte una copia de la guía de despacho firmada.
            </small>
            <div *ngIf="mailEmbedded.invalid && mailEmbedded.dirty && mailEmbedded.value">
              <small class="text-danger" *ngIf="mailEmbedded.errors?.pattern">
                Por favor ingresa un correo válido.
              </small>
            </div>
          </div>
        </div>

        <div class="firma-form-row">
          <label class="firma-form-label" for="firmaCorreoDos">CORREO 2</label>
          <div class="firma-correo-wrap">
            <input
              id="firmaCorreoDos"
              class="form-control firma-form-control"
              type="email"
              name="mailReceptorDos"
              [(ngModel)]="data.mailDos"
              placeholder="Ingresa un correo adicional"
              #mailDosEmbedded="ngModel"
              [ngModelOptions]="{ updateOn: 'blur' }"
              [pattern]="emailPattern" />
            <small class="firma-correo-hint">
              Correo adicional para enviar una copia de la guía de despacho firmada.
            </small>
            <div *ngIf="mailDosEmbedded.invalid && mailDosEmbedded.dirty && mailDosEmbedded.value">
              <small class="text-danger" *ngIf="mailDosEmbedded.errors?.pattern">
                Por favor ingresa un correo válido.
              </small>
            </div>
          </div>
        </div>

        <div class="firma-form-row firma-form-row--signature">
          <label class="firma-form-label">FIRMA</label>
          <div class="firma-signature-wrap">
            <app-signature-pad
              [value]="data.signature"
              [allowAttach]="true"
              [canvasWidth]="600"
              [canvasHeight]="300"
              [topReserveRatio]="0.25"
              (valueChange)="onSignatureChange($event)">
            </app-signature-pad>
          </div>
        </div>
      </ng-container>

      <!-- Default: original layout -->
      <ng-container *ngIf="!embedded">
        <div class="col-xl-12 p-0">
          <div class="col-xl-12">
            <input
              class="form-input mat-input form-control"
              [type]="'text'"
              name="NombreRecptor"
              [(ngModel)]="data.name"
              placeholder="Ingresa tu nombre" />
            <label class="mat-label label-input" for="Obs">Nombre</label>
          </div>
          <div class="col-12"><br /></div>

          <div class="row col-xl-12 d-flex flex-wrap align-items-center">
            <div class="col-xl-4 col-md-5 col-sm-5 col-6 mb-3">
              <input
                class="form-input mat-input form-control"
                [type]="'number'"
                minlength="7"
                maxlength="8"
                name="RutReceptor"
                [(ngModel)]="data.rut"
                placeholder="Ingresa tu RUT"
                (keydown)="onKeyDown($event)"
                pattern="^\d{6,7}[0-9kK]{1}$" />
              <label class="mat-label label-input" for="Obs">Rut</label>
            </div>
            <div class="col-xl-1 col-md-1 col-sm-1 col-1 mb-3">
              <strong>-</strong>
            </div>
            <div class="col-xl-3 col-md-4 col-sm-4 col-4 mb-3">
              <input
                class="form-input mat-input form-control"
                [type]="'text'"
                minlength="1"
                maxlength="1"
                name="dvRutReceptor"
                [(ngModel)]="data.dvrut"
                placeholder="Dv"
                (ngModelChange)="onDvRutChange($event)"
                (keydown)="onKeyDown($event)"
                pattern="^[0-9kK]{1}$"
                #dvRutReceptor="ngModel"
                style="width: 5ch; margin-left: -10%" />
              <label class="mat-label label-input" for="Obs">DV</label>
            </div>
          </div>

          <div class="col-12"><br /></div>
          <div class="col-xl-12">
            <input
              class="form-input mat-input form-control"
              type="email"
              name="mailReceptor"
              [(ngModel)]="data.mail"
              placeholder="Ingresa tu correo"
              #mail="ngModel"
              [ngModelOptions]="{ updateOn: 'blur' }"
              [pattern]="emailPattern" />
            <label class="mat-label label-input" for="Obs">Correo</label>
            <small class="text-info">
              Este mail lo utilizaremos para mandarte una copia de la guía de despacho firmada.
            </small>
            <div *ngIf="mail.invalid && mail.dirty && mail.value">
              <small class="text-danger" *ngIf="mail.errors?.pattern">
                Por favor ingresa un correo válido.
              </small>
            </div>
          </div>
        </div>
        <div class="firma-container col-xl-12">
          <app-signature-pad
            [value]="data.signature"
            [allowAttach]="true"
            [canvasWidth]="600"
            [canvasHeight]="300"
            [topReserveRatio]="0.25"
            (valueChange)="onSignatureChange($event)">
          </app-signature-pad>
        </div>

        <div class="d-flex mt-4">
          <div class="col-2 d-flex align-items-center justify-content-center col-icon-img">
            <i class="bi bi-exclamation-triangle-fill modal-warning-icon"></i>
          </div>
          <div>
            <label class="text-firma">
              Esta firma también será considerada en el caso de adición de agua y/u otros.
            </label>
          </div>
        </div>
      </ng-container>

      <p *ngIf="alreadySigned" class="text-info mt-2">
        Esta guía ya fue firmada.
      </p>
    </div>

    <div [class.firma-form-actions]="embedded">
      <button
        type="button"
        class="btn btn-primary"
        [class.btn-guardar-firma]="embedded"
        (click)="saveData()"
        [disabled]="isDisabled()">
        {{ submitting ? 'Enviando...' : (embedded ? 'Guardar' : 'Aceptar') }}
      </button>
    </div>
  </form>
</div>

<div class="margin-lateral-modal">
  <ng-template #contenidoModal>
    <div class="firma-success-modal">
      <div style="text-align: center">
        <i class="bi bi-check-circle-fill modal-success-icon"></i><br />
        <h6 class="text-title-modal">
          {{ savedOffline ? 'Firma guardada' : 'Guía firmada con éxito' }}
        </h6>
        <p class="text-descripcion-modal">
          {{
            savedOffline
              ? 'Tu firma se enviará al servidor cuando recuperes conexión.'
              : serverConfirmed
                ? 'Firma enviada correctamente al servidor.'
                : ''
          }}
        </p>
      </div>

      <div>
        <button type="button" class="btn btn-primary" (click)="savedOffline ? goBackToPedidosPendientes() : goBack()">
          Aceptar
        </button>
      </div>
    </div>
  </ng-template>
</div>

<app-aridos-encuesta-satisfaccion
  [(isSurveyVisible)]="surveyVisible"
  [receiverName]="data.name"
  (surveySubmittedSuccessEvent)="showModalSurveySuccess($event)">
</app-aridos-encuesta-satisfaccion>

